import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import "./Glance.css";
import { TbTableFilled } from "react-icons/tb";
import { PiHourglassMediumFill } from "react-icons/pi";
import { SiMicrostrategy } from "react-icons/si";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import about_operations_2_1 from "../../assets/images/about_operations_2-1.webp";
import about_operations_1 from "../../assets/images/about_operations_1.webp";
import { useNavigate } from "react-router-dom";
function Glance() {
  const navigate = useNavigate();

  return (
    <div>
      <Header />
      <div className="glance">
        <section className="contact__main__section__one">
          <h1>GuineGulf Energy at a glance</h1>
        </section>
        <section className="sustainability__main__section__two">
          <h1>
            GuineGulf Energy is at the forefront of Africa’s trading, onshore
            and offshore solutions, logistics and maritime services.
          </h1>
          <hr />
          <h3>
            With a commitment to sustainability and innovation, we provide
            expert solutions in our operations, trading, and offshore and
            onshore development. Our team of seasoned professionals is dedicated
            to delivering excellence and value to our clients and partners.
          </h3>
          <p>
            At GuineGulf Energy, our services cover a diverse spectrum of marine
            and energy solutions, ensuring that our clients receive customized
            support aligned with their specific goals and needs. By leveraging
            our expertise in marine logistics, trading, vessel handling, and
            equipment leasing, we provide comprehensive assistance that
            addresses every aspect of the maritime and energy sectors. At
            GuineGulf Energy, we are committed to being a trusted partner and a
            driving force in advancing sustainable development and operational
            excellence across Africa’s marine and energy industries.
          </p>
        </section>
        <section className="glance__section__three">
          <h1>Learn more about GuineGulf Energy:</h1>
          <div className="glance__section__three__explore">
            <div
              onClick={() => {
                navigate("/about/glance");
              }}
            >
              <TbTableFilled className="glance__section__three__explore__icon" />
              <h1>GuineGulf Energy at a Glance</h1>
              <p>
                GuineGulf Energy is a leading provider of marine and energy
                solutions, dedicated to delivering innovative services across
                trading, logistics, and vessel operations, with a focus on
                sustainable growth and excellence.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/about/purpose");
              }}
            >
              <PiHourglassMediumFill className="glance__section__three__explore__icon" />
              <h1>Our Purpose</h1>
              <p>
                To create value by delivering reliable, efficient, and
                customized solutions across the marine and energy industries
                while fostering sustainable practices.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/about/strategy");
              }}
            >
              <SiMicrostrategy className="glance__section__three__explore__icon" />
              <h1>Our Strategy</h1>
              <p>
                Build a comprehensive portfolio of services, including trading,
                marine logistics, vessel handling, equipment leasing, and waste
                management, to support the evolving needs of clients in Nigeria
                and West Africa.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/operations");
              }}
            >
              <MdOutlineMiscellaneousServices className="glance__section__three__explore__icon" />
              <h1>Our Operations</h1>
              <p>
                Our leadership team combines diverse business expertise and
                extensive industry experience to drive operational excellence
                and innovation in all aspects of our services.
              </p>
            </div>
          </div>
        </section>
        <section className="glance__section__four">
          <div className="glance__section__four__details">
            <h3>Our Network</h3>
            <h1>Nigeria</h1>
            <hr />
            <p>
              At GuineGulf Energy, we embrace a forward-thinking mindset and
              innovative approach to addressing critical inefficiencies within
              Nigeria's marine and energy sectors. Recognizing these gaps, we
              have taken strategic steps to bridge them by offering
              comprehensive marine logistics, vessel handling, and equipment
              leasing services that streamline operations across the entire
              value chain. Our unmatched consistency and expertise ensure
              uninterrupted service delivery, guaranteeing that our clients
              receive timely and reliable solutions tailored to their needs.
              With robust logistics capabilities and an optimized operational
              network, we deliver on customer orders efficiently and within
              agreed timelines, reinforcing our commitment to excellence and
              reliability in every aspect of our operations.
            </p>
          </div>
          <div className="glance__section__four__details__display">
            <img src={about_operations_2_1} alt="" />
            <img src={about_operations_1} alt="" />
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Glance;
